import { useState } from 'react'
import styled from '@emotion/styled'
import { Form, Button, Icon, Loader } from 'util/ui'
import { generateAutoLoginUrl } from 'util/auth'
import LoginLayout from '../LoginLayout'

const ButtonIcon = styled(Icon)`
  margin-left: ${props => props.theme.spacing['7']} !important;
  line-height: 0.6em !important;
  vertical-align: middle !important;
  opacity: 1 !important;
  color: ${props => props.theme.color.monochrome.dark} !important;
`

const LoaderIcon = styled(Loader)`
  margin-top: -0.1em !important;
  margin-left: ${props => props.theme.spacing['7']} !important;
  width: 8px !important;
`

const NarrowForm = styled(Form)`
  overflow-wrap: break-word;
`

const LoginMultipleAccounts = ({ accounts }) => {
  const [selectedSubdomain, setSelectedSubdomain] = useState(null)

  return (
    <LoginLayout
      greeting="Welcome back"
      tagline="Which account would you like to log into?"
    >
      <NarrowForm size="large">
        {accounts.map(({ subdomain, token, company }) => {
          return (
            <Form.Field key={subdomain}>
              <Button
                basic
                disabled={!!selectedSubdomain}
                fluid
                as="a"
                href={generateAutoLoginUrl(subdomain, token)}
                // eslint-disable-next-line react/jsx-no-bind
                onClick={() => setSelectedSubdomain(subdomain)}
                size="large"
              >
                {company || subdomain}
                {selectedSubdomain === subdomain ? (
                  <LoaderIcon active inline size="tiny" />
                ) : (
                  <ButtonIcon name="arrow right" size="tiny" />
                )}
              </Button>
            </Form.Field>
          )
        })}
      </NarrowForm>
    </LoginLayout>
  )
}

export default LoginMultipleAccounts
